export enum ModuleFeatureContentTabStatus {
    Hidden = 'inactive',
    AdminsOnly = 'admins_only',
    Active = 'active',
}
